import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";

import useRecentLeads from "../../datahooks/useRecentLeads";
import RecentLeadsItem from "./RecentLeadsItem";
import RecentLeadsItemLoader from "./RecentLeadsItemLoader";

import DripImage from "assets/images/empty-placeholders/messages.png";
import LeadsImage from "assets/images/empty-placeholders/no-profiles.png";

interface RecentLeadsProps {
  accountIds: string[];
  onSelectLead: (leadId: string) => void;
  isDrip?: boolean;
  flowId?: string;
  campaignId?: string;
}

export default function RecentLeads({
  accountIds,
  onSelectLead,
  isDrip = false,
  flowId = null,
  campaignId = null,
}: RecentLeadsProps) {
  const {
    recentLeads,
    isLoadingRecentLeads,
    recentLeadsError,
    refetchRecentLeads,
  } = useRecentLeads({ flowId, campaignId, accountIds });

  if (recentLeadsError) {
    return (
      <ErrorPlaceholder
        errorMessage="Could not display recent Leads"
        onRetry={refetchRecentLeads}
      />
    );
  }
  if (isLoadingRecentLeads) {
    return <RecentLeadsItemLoader />;
  }
  if (recentLeads && recentLeads.length) {
    let originType: "campaign" | "flow";

    if (!flowId && !campaignId) {
      originType = "campaign";
    } else if (campaignId && !flowId) {
      originType = "flow";
    }
    return (
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
        {recentLeads.map((lead) => {
          const { target_id: targetId } = lead;

          return (
            <RecentLeadsItem
              key={targetId}
              lead={lead}
              onLeadSelect={() => {
                onSelectLead(targetId);
              }}
              originType={originType}
            />
          );
        })}
      </div>
    );
  }
  let emptySubtitle =
    "Once you start getting new connections and replies to your campaigns, they will show up here";

  if (flowId || campaignId) {
    emptySubtitle = `It looks like you did not get any recent ${isDrip ? "replies" : "leads"} from this ${flowId ? "flow" : "campaign"}. Make sure the campaign is active, and they will show up in no time`;
  }

  return (
    <EmptyPlaceholder
      imageSrc={isDrip ? DripImage : LeadsImage}
      title={`No recent ${isDrip ? "replies" : "leads"}`}
      subtitle={emptySubtitle}
    />
  );
}
